import React from 'react';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import PortraitStage from './components/PortraitStage';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

/** html5-qrcode leaves orphaned video.play() promises when the scan screen unmounts. */
function isOrphanedMediaPlayError(reason) {
  if (!reason) return false;
  const name = String(reason.name || '');
  const message = String(reason.message || reason || '');
  const looksLikePlayAbort =
    message.includes('play()') ||
    message.includes('media was removed') ||
    message.includes('The play() request was interrupted');
  return looksLikePlayAbort && (name === 'AbortError' || name === 'NotAllowedError' || !name);
}

window.addEventListener(
  'unhandledrejection',
  (event) => {
    if (!isOrphanedMediaPlayError(event.reason)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PortraitStage>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="dark"
      />
      <div className="portraitPage">
        <App />
      </div>
    </PortraitStage>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
